<template>
  <div>
    <div class="panel panel-default">
      <div class="panel-body">
        <div class="pull-right">
          <button
            type="button"
            class="btn btn-primary brg__button-margin--bottom"
            @click="$emit('edit-business-rule-group', true)"
            v-permissions:configuration_business_rule_group.create
          >
            <i class="fas fa-plus"></i>
            Nova Regra de Negócio (BRG)
          </button>
        </div>
        <loading v-if="$apollo.queries.businessRuleGroups.loading" full-screen="false" size="small" />

        <table
          class="table table-striped table-bordered"
          v-else-if="businessRuleGroups && filteredBRGs.length > 0"
        >
          <thead>
            <tr>
              <th>ID</th>
              <th>Válido desde</th>
              <th>Válido até</th>
              <th>Campus</th>
              <th>Curso</th>
              <th>Nível</th>
              <th>Modalidade</th>
              <th>Turno</th>
              <th>Semestre</th>
              <th>Origem</th>
              <th>Prioridade</th>
              <th>Regras</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="rule in filteredBRGs" :key="rule.id" :class="{ 'warning' : !rule.enabled }">
              <td>{{ rule.id }}</td>
              <td>{{ rule.validFrom | formatDate }}</td>
              <td>{{ rule.validUntil | formatDate }}</td>
              <td>{{ rule.campus ? rule.campus.name : '' }}</td>
              <td>{{ rule.course ? rule.course.name : '' }}</td>
              <td>{{ rule.level ? rule.level.name : '' }}</td>
              <td>{{ rule.kind ? rule.kind.name : '' }}</td>
              <td>{{ rule.shift ? rule.shift.name : '' }}</td>
              <td>{{ rule.enrollmentSemester }}</td>
              <td>{{ rule.translatedOrigin }}</td>
              <td>{{ rule.priority }}</td>
              <td class="table-centralized">
                <button
                  class="btn btn-info"
                  title="Visualizar"
                  data-toggle="tooltip"
                  @click.prevent="openRulesModal(rule)"
                >
                  <i class="fas fa-eye"></i>
                </button>
                <button
                  class="btn btn-primary brg__button-margin--left"
                  title="Editar"
                  data-toggle="tooltip"
                  v-permissions:configuration_business_rule_group.update
                  @click.prevent="$emit('selected-business-rule-group', rule)"
                >
                  <i class="fas fa-edit"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <div v-else-if="error">
          {{ error }}
        </div>

        <div v-else>
          Nenhum resultado
        </div>

        <rules-modal
          :rule="selectedRule"
          @close="closeRulesModal"
          v-if="selectedRule"
        />

        <a href="javascript:void(0)" @click="toggleBRGsFilter()">
          <template v-if="onlyEnabled">
            Mostrar
          </template>
          <template v-else>
            Esconder
          </template>
          regras desabilitadas ( {{ disabledBRGs.length }} )
        </a>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
  @import 'assets/stylesheets/utils/_spacing.sass';

  .brg__button-margin--bottom {
    margin-bottom: $space-m;
  }

  .brg__button-margin--left {
    margin-left: 5px;
  }
</style>

<script>
import BusinessRuleGroupsQuery from 'queries/BusinessRuleGroupsQuery.gql';
import Loading from 'components/Loading';
import Permissions from 'mixins/Permissions';
import RulesModal from './components/RulesModal';

export default {
  mixins: [Permissions],
  components: {
    Loading,
    RulesModal,
  },
  data() {
    return {
      selectedRule: null,
      showRulesModal: false,
      error: null,
      onlyEnabled: true,
    };
  },
  computed: {
    institutionId() {
      return parseInt(this.$route.params.id, 10);
    },
    filteredBRGs() {
      if (this.onlyEnabled) {
        return this.businessRuleGroups.filter(brg => brg.enabled);
      }

      return this.businessRuleGroups;
    },
    disabledBRGs() {
      if (!this.businessRuleGroups) {
        return [];
      }
      return this.businessRuleGroups.filter(brg => brg.enabled === false);
    },
  },
  apollo: {
    businessRuleGroups: {
      query: BusinessRuleGroupsQuery,
      variables() {
        return {
          institutionId: this.institutionId,
        };
      },
      error(error) {
        this.error = error.gqlError.message;
      },
    },
  },
  methods: {
    openRulesModal(rule) {
      this.selectedRule = rule;
      this.showRulesModal = true;
    },
    closeRulesModal() {
      this.selectedRule = null;
      this.showRulesModal = false;
    },
    toggleBRGsFilter() {
      if (this.disabledBRGs.length > 0) {
        this.onlyEnabled = !this.onlyEnabled;
      }
    },
    initializeTooltips() {
      $(() => {
        $('[data-toggle="tooltip"]').tooltip();
      });
    },
  },
  mounted() {
    this.initializeTooltips();
    this.$apollo.queries.businessRuleGroups.refetch();
  },
};
</script>
